const $ = jQuery.noConflict();

'use strict';
const RemoveDisabledUpload = {
	$domUploadbtn: $('.gform_button_select_files'),

	init: function() {
		this.removeDisabled();
	},

	removeDisabled: function() {
		$('#edit').click(function(event){
			event.preventDefault();
			RemoveDisabledUpload.$domUploadbtn.prop('disabled', false);

		});
	},
};

export default RemoveDisabledUpload;